import "firebase/database";
import React, { useEffect, useState } from "react";
import { Dimensions, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Button, Input } from "react-native-elements";
import { RFValue } from "react-native-responsive-fontsize";
import rejectNotarize from "../../networking/api/verification/rejectNotarize";

const { width, height } = Dimensions.get("window");

const texts = [
  "One or more documents were unacceptable",
  "One or more documents were not legible",
  "One or more documents were incorrect",
];

const RejectionReason = ({ setOpen, userRef, open }) => {
  const [input, setInput] = useState("");
  useEffect(() => {
    setInput("");
  }, [open]);
  return (
    <View style={styles.renderContent}>
      <Input
        value={input}
        onChangeText={(e) => setInput(e)}
        inputStyle={styles.inputStyle}
        inputContainerStyle={styles.inputContainerStyle}
      />
      <View style={styles.rowView}>
        {texts.map((o, i) => (
          <TouchableOpacity style={styles.view} key={o + i.toString()} onPress={() => setInput(o)}>
            <Text style={styles.text}>{o}</Text>
          </TouchableOpacity>
        ))}
      </View>
      <Button
        title="Submit"
        disabled={!input.trim()}
        buttonStyle={styles.buttonStyle}
        titleStyle={styles.titleStyle}
        onPress={async () => await rejectNotarize(userRef, input, (e) => setOpen(e))}
      />
    </View>
  );
};

export default RejectionReason;

const styles = StyleSheet.create({
  rowView: {
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
  },
  text: { fontFamily: "avenir", fontSize: RFValue(12) },
  view: {
    padding: 5,
    margin: 5,
    flex: 1,
    borderWidth: 1,
    borderColor: "gray",
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  inputContainerStyle: {
    borderWidth: 1,
    borderRadius: 5,
  },
  inputStyle: {
    fontSize: RFValue(14),
    alignSelf: "flex-start",
    fontFamily: "avenir",
    marginHorizontal: 5,
    outlineWidth: 0,
  },
  renderContent: {
    marginTop: height * 0.01,
    backgroundColor: "white",
    borderBottomWidth: 0,
  },
  knob: {
    alignSelf: "center",
    width: width * 0.1,
    height: 5,
    marginVertical: 5,
    backgroundColor: "gray",
    borderRadius: 7.5,
  },
  titleStyle: { fontFamily: "avenir", fontSize: RFValue(14) },
  buttonStyle: {
    backgroundColor: "#181d21",
    borderRadius: 5,
    margin: width * 0.05,
  },
});
